// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__3fLch","title":"ClientInsurance_title__8ZD1u","itemText":"ClientInsurance_itemText__5Zr-7"};